import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./SuperadminHeader.css";

const API_URL = process.env.REACT_APP_API_URL;

const SuperadminHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [user, setUser] = useState(null);

    const fetchUserDetails = useCallback(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    useEffect(() => {
        fetchUserDetails();
    }, [fetchUserDetails]);

    const handleLogout = async () => {
        try {
            await axios.post(`${API_URL}api/logout/`, {}, { withCredentials: true });
            localStorage.clear();
            navigate('/login');
        } catch (error) {
            console.error("Logout failed", error);
        }
    };

    const toggleSidebar = (e) => {
        e.preventDefault();
        const body = document.body;
        if (window.innerWidth >= 992) {
            body.classList.toggle('sidebar-collapse');
        } else {
            if (body.classList.contains('sidebar-open')) {
                body.classList.remove('sidebar-open');
                body.classList.add('sidebar-collapse');
            } else {
                body.classList.add('sidebar-open');
                body.classList.remove('sidebar-collapse');
            }
        }
    };

    const getPageTitle = (path) => {
        const titles = {
            '/superadmin_dashboard': 'Superadmin Dashboard',
            '/superadmin_storage': 'Storage Management',
            '/superadmin_ai_usage': 'AI Usage & Limits',
            '/superadmin_upgrade_requests': 'Upgrade Requests',
            '/superadmin_enquiries': 'Website Enquiries (CARAgrc)',
            '/superadmin_cyberinsurify_enquiries': 'Website Enquiries (CyberInsurify)',
            '/create_cara_admin': 'Create CARA Admin',
            '/create_cara_admin_v2': 'Create CARA Admin (V2)',
            '/superadmin_manage_admins': 'Manage CARA Admins',
            '/create_cara_vrm': 'Create VRM',
            '/superadmin_vrm_mapping': 'VRM Mapping',
            '/policy_library_admin': 'Policy Library',
            '/create_super_admin': 'Create SuperAdmin',
        };
        return titles[path] || 'Superadmin Dashboard';
    };

    return (
        <nav className="main-header navbar navbar-expand sa-header fixed-top">
            <div className="sa-header-left">
                <div className="sa-header-toggle" onClick={toggleSidebar} role="button">
                    <i className="fas fa-bars"></i>
                </div>
                <span className="sa-header-title">{getPageTitle(location.pathname)}</span>
            </div>

            <div className="sa-header-right">
                <div className="dropdown">
                    <div className="sa-user-menu" data-toggle="dropdown" role="button">
                        <div className="sa-user-avatar">
                            <i className="far fa-user"></i>
                        </div>
                        <span className="sa-user-name">
                            {user ? `${user.first_name} ${user.last_name}` : 'Superadmin'}
                        </span>
                        <i className="fas fa-chevron-down sa-user-chevron"></i>
                    </div>
                    
                    <div className="dropdown-menu dropdown-menu-right sa-dropdown-menu">
                        <span className="dropdown-item dropdown-header sa-dropdown-header">Profile Options</span>
                        <div className="dropdown-divider sa-dropdown-divider"></div>
                        <a href="#" className="dropdown-item sa-dropdown-item text-danger" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                            <i className="fas fa-sign-out-alt mr-2"></i> Secure Logout
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default SuperadminHeader;
